export const OPTION_LABELS = {
  colours: "Colour",
  fabrics: "Fabric",
  lengths: "Length",
  necklines: "Neckline",
  sleeves: "Sleeve",
  sizes: "Size",
};
export const OPTION_ORDER = ["colours", "fabrics", "lengths", "necklines", "sleeves", "sizes"];

export const optionLabel = (k) => OPTION_LABELS[k] || k.charAt(0).toUpperCase() + k.slice(1);

export default function OptionGroup({ label, values, selected, onSelect, testid }) {
  return (
    <div data-testid={testid}>
      <span className="overline mb-3 block text-muted">{label}</span>
      <div className="flex flex-wrap gap-2.5">
        {values.map((v) => (
          <button
            key={v}
            type="button"
            onClick={() => onSelect(v)}
            data-testid={`${testid}-${v}`}
            className={`border px-4 py-2 font-body text-sm transition-colors duration-300 ${
              selected === v ? "border-ink bg-ink text-paper" : "border-ink/25 text-stone hover:border-ink"
            }`}
          >
            {v}
          </button>
        ))}
      </div>
    </div>
  );
}
